/* global axios */
import ApiClient from './ApiClient';

// Clasificación de plantillas POR BANDEJA: cada bandeja tiene sus secciones
// personalizadas y su orden. Sin inboxId el backend asume la bandeja legacy.
class TemplateClassificationsAPI extends ApiClient {
  constructor() {
    super('template_classifications', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }

  reorder(inboxId, items) {
    return axios.put(`${this.url}/reorder`, { inbox_id: inboxId, items });
  }

  rename(inboxId, templateName, displayName) {
    return axios.patch(`${this.url}/rename`, {
      inbox_id: inboxId,
      template_name: templateName,
      display_name: displayName,
    });
  }

  refreshAll() {
    return axios.post(`${this.url}/refresh_all`);
  }
}

export default new TemplateClassificationsAPI();
